import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { MemberProfile, MemberFranchiseItem } from '../models/member.interface';
import { Visit } from '@lib/core/models/visit.interface';
import { PagedResponse } from '@lib/core/models/paged-response';
import { MEMBERS_API_URL } from '../tokens/api.tokens';

export interface VisitSearchParams {
  userId: string;
  page: number;
  pageSize: number;
  status: string;
  sortBy: string;
}

@Injectable({
  providedIn: 'root',
})
export class MemberHubService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl: string;

  constructor(@Inject(MEMBERS_API_URL) apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  getMemberProfile(memberId: string): Observable<MemberProfile | null> {
    return this.http.get<MemberProfile>(`${this.apiUrl}/members/${memberId}`);
  }

  getPackageFranchisesByMemberId(memberId: string): Observable<MemberFranchiseItem[]> {
    return this.http.get<MemberFranchiseItem[]>(`${this.apiUrl}/members/${memberId}/franchises`);
  }

  searchVisits(params: VisitSearchParams): Observable<PagedResponse<Visit>> {
    const requestBody = {
      userId: params.userId,
      page: params.page,
      pageSize: params.pageSize,
      status: params.status,
      sortBy: params.sortBy,
    };
    return this.http.post<PagedResponse<Visit>>(`${this.apiUrl}/members/actions/search`, requestBody);
  }
}